import api from '@/api/axiosConfig';
import { cases,
    experts,institutions,conferenceUnits,eventsDetail,eventsOverview,eventCases,eventForums
  } from '@/mock/data'
export const getCases= (province,page,pageSize) => api.get(`/achievement/cases?province=${province}&page=${page}&pageSize=${pageSize}`)
export const getCaseDetail= (id) => api.get(`/caseNews/detail?id=${id}`)
/**
 * 典型院校
 * @param {a} page 
 * @param {*} pageSize 
 * @returns 
 */
export const     getInstitutions= (province,page,pageSize) => api.get(`/achievement/colleges?page=${page}&pageSize=${pageSize}&province=${province}`)
export const getContributors= (page,pageSize) => api.get(`/achievement/contributors?page=${page}&pageSize=${pageSize}`)
export const getEducators= (page,pageSize) => api.get(`/achievement/educators?page=${page}&pageSize=${pageSize}`)
export const getProject= (page,pageSize) => api.get(`/project/list?page=${page}&pageSize=${pageSize}`)
export const getProjectDetail= (id) => api.get(`/project/detail?id=${id}`)

export const getColumnList= (page,pageSize) => api.get(`/column/list?page=${page}&pageSize=${pageSize}`)
export const getColumnDetail= (id,page,pageSize) => api.get(`/column/detail?id=${id}&page=${page}&pageSize=${pageSize}`)
export const getColumnNewsDetail= (id) => api.get(`/column/newsDetail?id=${id}`)

export default{
  getCases,
  getInstitutions,
  getContributors,
  getEducators,
  getProject,
  getProjectDetail,
  getColumnList,
  getColumnDetail,
  getColumnNewsDetail,
  getCaseDetail
}